import { type IntlShape } from "react-intl";
import { z } from "zod";

const pickZoneStatuses = ["Normal", "Stop"] as const;

export const getPickZoneStatusSchema = (intl: IntlShape) =>
	z.enum(
		pickZoneStatuses,
		intl.formatMessage({ id: "Pick zone status is invalid", defaultMessage: "Pick zone status is invalid" }),
	);

export const getPickZoneConfigurationSchema = (intl: IntlShape) =>
	z.object({
		alias: z
			.string(intl.formatMessage({ id: "Alias needs to be a string", defaultMessage: "Alias needs to be a string" }))
			.trim()
			.nonempty(intl.formatMessage({ id: "Alias can not be empty", defaultMessage: "Alias can not be empty" })),
		description: z
			.string(
				intl.formatMessage({
					id: "Description needs to be a string",
					defaultMessage: "Description needs to be a string",
				}),
			)
			.trim(),
	});

export const getPickZoneStatusUpdateSchema = (intl: IntlShape) =>
	z.object({
		status: getPickZoneStatusSchema(intl),
	});

export const getPickZoneSchema = (intl: IntlShape) =>
	getPickZoneConfigurationSchema(intl)
		.extend(getPickZoneStatusUpdateSchema(intl).shape)
		.extend({
			id: z
				.string(intl.formatMessage({ id: "Id needs to be a string", defaultMessage: "Id needs to be a string" }))
				.trim()
				.nonempty(intl.formatMessage({ id: "Id can not be empty", defaultMessage: "Id can not be empty" })),
			tenantId: z
				.string(
					intl.formatMessage({ id: "TenantId needs to be a string", defaultMessage: "TenantId needs to be a string" }),
				)
				.trim()
				.nonempty(intl.formatMessage({ id: "TenantId can not be empty", defaultMessage: "TenantId can not be empty" })),
			description: z
				.string(
					intl.formatMessage({
						id: "Description needs to be a string or null",
						defaultMessage: "Description needs to be a string or null",
					}),
				)
				.trim()
				.nullable()
				.transform((val) => val ?? ""),
		});

export type PickZone = z.infer<ReturnType<typeof getPickZoneSchema>>;
export type PickZoneConfiguration = z.infer<ReturnType<typeof getPickZoneConfigurationSchema>>;
export type PickZoneStatus = z.infer<ReturnType<typeof getPickZoneStatusSchema>>;
export type PickZoneStatusUpdate = z.infer<ReturnType<typeof getPickZoneStatusUpdateSchema>>;
